<template>
  <div class="trip-banner" @click="onClickButtonBanner">
    <p id="banner-title">アンケートに回答</p>
    <p id="banner-detail">１万円分の景品をゲット！</p>
  </div>
</template>


<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState([
      "registrationId",
    ]),
  },
  methods: {
    onClickButtonBanner() { 
      window.open(
        `https://docs.google.com/forms/d/e/1FAIpQLSe5VZ0GzUH1Ya6F19IbmSq0xJfU8o_57n3jkMuh3sG70eVYfw/viewform?usp=sf_link&entry.1414804583=${this.registrationId}`,
        "_blank",
      );
    },
  },
}

</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.trip-banner
{
  position: fixed;
  left: 0.5rem;
  bottom: 3.0rem;
  z-index: 2;
  border-radius: 8px;
  background: #EF8389;
  padding-left: 16px;
  padding-right: 16px;
}
#btn-trip-banner
{
  width: 10rem;
}
#banner-title
{
  color: #FFFFFF;
  font-size: 0.8em;
  font-weight:bold;
  line-height: 0.3;
}
#banner-detail
{
  color: #FFFFFF;
  font-size: 0.6em;
  line-height: 0;
}
</style>





// WEBPACK FOOTER //
// src/components/JyutaiSearch/TripSurveyBanner.vue